import { render, staticRenderFns } from "./TrimCard.vue?vue&type=template&id=3f73a6af&"
import script from "./TrimCard.vue?vue&type=script&lang=js&"
export * from "./TrimCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports